export default {"src":"/_next/static/media/Pericarditis.b6216eff.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};